export const getEstimatePrice = (
  shumaTypeID,
  originTypeID,
  estimatePriceFinalRounded,
  finalMarketPrice,
  propertyPriceMinusDepreciation,
  estimatePriceFinal
) => {
  if (originTypeID === 3) {
    return estimatePriceFinal
      ? Math.floor(estimatePriceFinal)
      : '';
  } else {
    switch (shumaTypeID) {
      case 1:
        return estimatePriceFinalRounded
          ? Math.floor(estimatePriceFinalRounded)
          : '';
      case 2:
        return finalMarketPrice
          ? Math.floor(finalMarketPrice)
          : '';
      case 3:
      case 4:
        return propertyPriceMinusDepreciation
          ? Math.floor(propertyPriceMinusDepreciation)
          : '';
      default:
        return estimatePriceFinal
          ? Math.floor(estimatePriceFinal)
          : '';
    }
  }
};